import type { FeatureCollection } from 'geojson';
import type { LngLat } from './types.ts';
import { API_BASE } from './api.ts';

/**
 * Cart paths for one course. Fetched once, then cached on the device — a round
 * must never depend on the network, and paths do not move.
 */
const key = (courseId: string) => `fairway.cartpaths.${courseId}`;

const EMPTY: FeatureCollection = { type: 'FeatureCollection', features: [] };

export async function loadCartPaths(courseId: string, centre: LngLat): Promise<FeatureCollection> {
  try {
    const raw = localStorage.getItem(key(courseId));
    if (raw) return JSON.parse(raw) as FeatureCollection;
  } catch {
    /* fall through to network */
  }

  try {
    const r = await fetch(
      `${API_BASE}/api/cartpaths/${encodeURIComponent(courseId)}` +
        `?lat=${centre[1].toFixed(5)}&lng=${centre[0].toFixed(5)}`
    );
    if (!r.ok) return EMPTY;
    const geo = (await r.json()) as FeatureCollection;
    try {
      localStorage.setItem(key(courseId), JSON.stringify(geo));
    } catch {
      /* storage full on a cheap head unit — still usable this session */
    }
    return geo;
  } catch {
    return EMPTY;
  }
}

export function clearCartPathCache(courseId: string) {
  localStorage.removeItem(key(courseId));
}
